export const MODULE_NAME = 'creative-library';
export const CREATIVE_LIBRARY_ROUTE = `/${MODULE_NAME}`;
